module.exports = __webpack_public_path__ + "static/img/change-often-01.8bafe91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/change-often-01.jpg
// module id = 248
// module chunks = 1